import { render, staticRenderFns } from "./Upitnik15DaniCOVID.vue?vue&type=template&id=709e90be&scoped=true&"
import script from "./Upitnik15DaniCOVID.vue?vue&type=script&lang=js&"
export * from "./Upitnik15DaniCOVID.vue?vue&type=script&lang=js&"
import style1 from "./Upitnik15DaniCOVID.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709e90be",
  null
  
)

export default component.exports